import React from "react";
import { useTranslation } from "react-i18next";
import { TransformedProduct } from "../../types/productApiTypes";

interface ProductPriceDisplayProps {
  product: TransformedProduct;
  selectedVariation?: TransformedProduct | null;
  className?: string;
}

const ProductPriceDisplay: React.FC<ProductPriceDisplayProps> = ({
  product,
  selectedVariation,
  className = "",
}) => {
  const { t } = useTranslation();

  // B2B Approval check from window.commonVariables
  const isApprovedMember = Boolean(window.commonVariables?.isApprovedMember);
  const loginUrl = window.commonVariables?.loginUrl || "/login";

  // --- B2B CATALOG MODE: Hide prices if not an approved member ---
  if (!isApprovedMember) {
    return (
      <div className={`product-price product-price--login-prompt ${className}`}>
        <a
          href={loginUrl}
          className="product-price__login-link"
          style={{
            fontSize: "13px",
            fontWeight: "600",
            color: "var(--color-primary, #00b237)",
            textDecoration: "underline",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {t("productPrice.loginToSeePrice", "Fiyatı Görmek İçin Giriş Yapın")}
        </a>
      </div>
    );
  }

  const displayData = selectedVariation || product;
  const isOnSale = displayData.onSale;

  if (!displayData.formattedPrice) {
    return null;
  }

  const preferDefaultPrice =
    window.commonVariables?.uiSettings?.productCard
      ?.preferDefaultPriceOverRange || false;

  const isCardContext =
    className.includes("product-card__price") ||
    className.includes("product-panel-item__price");

  const bypassRange =
    preferDefaultPrice && isCardContext && product.hasDefaultVariation;

  if (
    !selectedVariation &&
    (product.type === "grouped" || product.isVariable) &&
    product.formattedMinPrice &&
    product.formattedMaxPrice &&
    !bypassRange
  ) {
    return (
      <div className={`product-price ${className}`}>
        <span className="product-price__current">
          {product.formattedMinPrice} – {product.formattedMaxPrice}
        </span>
      </div>
    );
  }

  if (isOnSale) {
    return (
      <div className={`product-price product-price--on-sale ${className}`}>
        <del aria-label="Original price" className="product-price__regular">
          {displayData.formattedRegularPrice}
        </del>
        <ins aria-label="Sale price" className="product-price__current">
          {displayData.formattedSalePrice}
        </ins>
      </div>
    );
  }

  return (
    <div className={`product-price ${className}`}>
      <span className="product-price__current">
        {displayData.formattedPrice}
      </span>
    </div>
  );
};

export default ProductPriceDisplay;
